module.exports = __webpack_public_path__ + "img/0xa4cfe5ea184a9a8bb2bb8377a378606a36ddea80.785c9b49.png";